<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Settings" class="d-icon d-icon--settings" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM5 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"/><path d="M4.83.94A1.5 1.5 0 0 1 5.89.5h.22A1.5 1.5 0 0 1 7.61 2v.093a.5.5 0 0 0 .25.429h.001l.215.125a.5.5 0 0 0 .522-.012l.06-.033a1.5 1.5 0 0 1 2.04.552l.11.19a1.502 1.502 0 0 1-.544 2.047l-.072.043-.011.006a.5.5 0 0 0-.246.433v.254a.5.5 0 0 0 .244.431l.066.036.016.008a1.5 1.5 0 0 1 .548 2.046l-.111.198a1.5 1.5 0 0 1-2.04.552l-.064-.035a.5.5 0 0 0-.518-.01l-.216.125a.5.5 0 0 0-.25.429V10a1.5 1.5 0 0 1-1.5 1.5h-.22a1.5 1.5 0 0 1-1.5-1.5v-.09a.5.5 0 0 0-.25-.432h-.001l-.215-.125a.5.5 0 0 0-.52.011l-.062.034a1.5 1.5 0 0 1-2.04-.552l-.11-.19a1.502 1.502 0 0 1 .544-2.047l.072-.043.011-.007a.5.5 0 0 0 .246-.432v-.255a.5.5 0 0 0-.25-.429.506.506 0 0 1-.034-.021l-.057-.038a1.5 1.5 0 0 1-.532-2.039l.11-.19a1.5 1.5 0 0 1 2.04-.553l.068.037a.5.5 0 0 0 .514.009l.216-.126a.5.5 0 0 0 .25-.433V2c0-.398.158-.78.44-1.06Zm4.105 4.934v.252a1.5 1.5 0 0 0 .77 1.313l.06.032a.5.5 0 0 1 .177.68l-.11.195a.5.5 0 0 1-.682.18l-.015-.007-.068-.037a1.5 1.5 0 0 0-1.492.005l-.216.125A1.5 1.5 0 0 0 6.61 9.91V10a.5.5 0 0 1-.5.5h-.22a.5.5 0 0 1-.5-.5v-.09a1.5 1.5 0 0 0-.75-1.298l-.214-.124-.001-.001a1.5 1.5 0 0 0-1.49-.005l-.07.037-.015.008a.5.5 0 0 1-.682-.183l-.11-.19a.5.5 0 0 1 .183-.681l.075-.046a1.5 1.5 0 0 0 .749-1.303v-.257a1.5 1.5 0 0 0-.734-1.28l-.064-.043a.5.5 0 0 1-.21-.7l.11-.189a.5.5 0 0 1 .683-.182l.015.008.067.036a1.5 1.5 0 0 0 1.493-.004l.216-.125a1.5 1.5 0 0 0 .749-1.295V2a.5.5 0 0 1 .5-.5h.22a.5.5 0 0 1 .5.5v.09a1.5 1.5 0 0 0 .75 1.298l.214.124.001.001a1.5 1.5 0 0 0 1.49.006l.07-.038.015-.008a.5.5 0 0 1 .682.183l.11.19a.5.5 0 0 1-.183.681l-.076.046a1.5 1.5 0 0 0-.548.549v.002a1.5 1.5 0 0 0-.2.75Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSettings',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
